// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NrEqkKC9CrIwlYxCYVwV{flex-direction:column;width:100%;max-width:772px;padding-bottom:10px;display:flex;overflow:auto}.HDzZiy27u9grrertnrLa{text-align:right;flex:none;width:54px;margin-top:-2px;margin-left:auto}.KRVo0VMgxsEpwDrSqtsa{margin-top:3px;margin-left:2px}.peI4ViFlpXoF5Wd4tSLJ{width:404px}@media (max-width:992px){.peI4ViFlpXoF5Wd4tSLJ{width:350px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NrEqkKC9CrIwlYxCYVwV`,
	"switcherWrap": `HDzZiy27u9grrertnrLa`,
	"error": `KRVo0VMgxsEpwDrSqtsa`,
	"messageFieldWrap": `peI4ViFlpXoF5Wd4tSLJ`
};
export default ___CSS_LOADER_EXPORT___;
